import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidKlankSwitch, TKlankSwitchAssignment } from '../../../../mechanics/rid-klank-switch/rid-klank-switch';
import { AnnotationUtils } from '../../../../utils/annotation.utils';
import { injectQueryParams } from '../../../../utils/route.utils';

const MEDIA = 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch';

const WORDS = [
  {
    image: `${MEDIA}/tRbHTlab4z8VFbpW_d-7z.png`,
    audio: `${MEDIA}/9CDLx_0IzhOzB4YS6MUAu.mp3`,
    annotatie: '>t/ij/<g/e/r',
  },
  {
    image: `${MEDIA}/BJuCpMZwjLRDH22qN_3C-.png`,
    audio: `${MEDIA}/JEOE5HvotZVLUtbnIaXb0.mp3`,
    annotatie: '>l/eeuw',
  },
  {
    image: `${MEDIA}/EnNEt6JxcpmKOEZK0mbG9.png`,
    audio: `${MEDIA}/AhhrL7MRNc_dvWAsx7YIf.mp3`,
    annotatie: '>z/-ee/>b/r/-aa',
  },
];

@Component({
  selector: 'app-klank-switch-page',
  imports: [RidKlankSwitch],
  templateUrl: './klank-switch-page.html',
})
export class KlankSwitchPage {
  protected readonly router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly shuffle = computed(() => parseInt(this.queryParams()['shuffle'] ?? '1'));
  protected readonly unit = computed(() => (this.queryParams()['unit'] === 'klankvoet' ? 'KLANKVOET' : 'KLANK'));

  protected readonly assignments = computed<TKlankSwitchAssignment[]>(() =>
    WORDS.map((word) => ({
      prompt: { type: 'CONTENT', layout: 'HORIZONTAL', image: word.image, audio: word.audio },
      word: AnnotationUtils.parse(word.annotatie),
      unit: this.unit(),
      shuffle: this.shuffle(),
    })),
  );
}
